<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Kasa Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search" label=" Ara" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>



            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout wrap="">

              <v-flex xs12 sm6 md3 pa-1 >
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Devir
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ devir }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Açılış Devir
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ acilisDevir }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Kasa Devir
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ kasaDevir }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> Devir </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ oncekiDonemAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Bakiye
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ oncekiDonemBakiye }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ oncekiDonemBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Önceki Dönem </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Toplam </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ donemAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ donemBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Dönem </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>



            </v-layout>
          </v-container>

          <v-container fluid>

            <v-card color="grey lighten-5" flat>
                   <v-form ref="formtarih" v-model="valid" lazy-validation>

              <v-layout row wrap>

            <v-flex xs12 sm6 md2>
                  <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>

                </v-flex>
                <v-flex xs12 sm6 md2>

                               <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>


                </v-flex>

                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                      color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                      <span>Arama Filtresi Ekle</span>
                    </v-tooltip>
                  </v-layout>
                </v-flex>


                <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
                  <v-card color="grey lighten-5">

                    <v-card-title>Filtre Seçimi</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row="" wrap="">



                <v-flex pa-1 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                          <v-layout justify-space-between column>
                            <v-select :items="doviztipi" label="Döviz Tipi" item-text="DovizAdi" hide-details=""
                              v-model="KasaRapor.Doviz.DovizKod" item-value="DovizKod" max-height="400"></v-select>
                            <v-select :items="evraktipi" hide-details="" label="Evrak Cinsi" multiple="" v-model="secilenevraklar"
                              item-text="Aciklama" clearable item-value="Evrakkod" max-height="400"></v-select>

                          </v-layout>
                              </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                            <br>
                            <v-flex pa-1 xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                          </v-card-title>
                        </v-card>
                            </v-flex>

                        <v-flex xs12 sm12 md6>
                          <v-layout justify-space-between column>
                            <v-radio-group label="Sıralama" v-model="KasaRapor.Siralama" column>
                              <v-radio checked="" label="Hesap Kodu" value='0'> </v-radio>
                              <v-radio label="Tarih" value='1'></v-radio>
                              <v-radio label="Döviz Tipi" value="2"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-layout justify-space-between column>
                            <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtreleri Uygula</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-flex xs12 sm12>
                  <v-card>
                    <v-card-title>
                      <v-spacer></v-spacer>

                    </v-card-title>
                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                      :search="search">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.Date }}</td>
                        <td class="text-xs-left">{{ props.item.DocumentType }}</td>
                        <td class="text-xs-left">{{ props.item.DocumentNumber}}</td>
                        <td class="text-xs-left">{{ props.item.Explanation}}</td>
                        <td class="text-xs-right">{{ props.item.Debt | moneyformat }}</td>
                        <td class="text-xs-right">{{ props.item.Credit | moneyformat }}</td>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                      </v-alert>
                    </v-data-table>
                  </v-card>
                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
                   </v-form>
            </v-card>
          </v-container>



        </v-layout>
      </v-card>
    </v-app>

  </div>
</template>


<script>
  import auth from '../../../api/auth'
    import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from "@/components/app/customcomp/tarihim"

  export default {
    data() {
      return {
        headers: [{
            text: ' Tarih',
            value: 'Date'
          },
          {
            text: 'Evrak Tipi',
            value: 'DocumentType'
          },
          {
            text: 'Evrak No',
            value: 'DocumentNumber'
          },
          {
            text: 'Açıklama',
            value: 'Explanation'
          },
          {
            text: 'Borç',
            value: 'Debt',
            align: 'right'
          },
          {
            text: 'Alacak',
            value: 'Credit',
            align: 'right'
          }
        ],
        KasaRapor: {

          SirketKodu: '',
          BaslangicTarih: '',
          BitisTarih: '',
          Doviz: {
            DovizKod: ''
          },
          Evraklar: [],
          Siralama: '0'


        },
        secilenevraklar: [],
        tumsirketler: '',
        devir: 0,
        acilisDevir: 0,
        kasaDevir: 0,
        oncekiDonemAlacak: 0,
        oncekiDonemBakiye: 0,
        oncekiDonemBorc: 0,
        toplamAlacak: 0,
        toplamBorc: 0,
        donemAlacak: 0,
        donemBorc: 0,
        StartDate: null,
        EndDate: null,


        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',

        evraktipi: [],
        doviztipi: [],
        anahesap: [],
valid:true,


        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        progress: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
        search: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

    },
    watch: {

    },
       filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }



  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }


  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false

  }

  function getList() {


          if (this.$refs.formtarih.validate()) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {

          this.devir = 0
          this.acilisDevir = 0
          this.kasaDevir = 0
          this.oncekiDonemAlacak = 0
          this.oncekiDonemBakiye = 0
          this.oncekiDonemBorc = 0
          this.toplamAlacak = 0
          this.toplamBorc = 0
          this.donemAlacak = 0
          this.donemBorc = 0

          this.progress = true
          this.load1 = false



          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var Evraklar1 = []
          if (this.secilenevraklar.length > 0) {
            Object.keys(this.secilenevraklar).forEach(key => {
              var evrak = {
                Evrakkod: this.secilenevraklar[key]
              }
              Evraklar1.push(evrak)
            });
          }

          this.KasaRapor.Evraklar = Evraklar1


          if (this.tumsirketler === true) {
            this.KasaRapor.SirketKodu = '0'
          } else {
            this.KasaRapor.SirketKodu = credentials.SirketKodu
          }
          this.KasaRapor.BaslangicTarih = this.date
          this.KasaRapor.BitisTarih = this.date2

          var params = this.KasaRapor


          this.$http.post(auth.API_URL + 'api/Report/CaseReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body.List
            this.devir = response.body.Devir.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.acilisDevir = response.body.AcilisDevir.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.kasaDevir = response.body.KasaDevir.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.oncekiDonemAlacak = response.body.OncekiDonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,')
            this.oncekiDonemBakiye = response.body.OncekiDonemBakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,')
            this.oncekiDonemBorc = response.body.OncekiDonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,')
            this.toplamAlacak = response.body.ToplamAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.toplamBorc = response.body.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.donemAlacak = response.body.DonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
            this.donemBorc = response.body.DonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true

            }
          })

        } else {
          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
      }


  }


  function getListHtml() {
    this.devir = 0
    this.acilisDevir = 0
    this.kasaDevir = 0
    this.oncekiDonemAlacak = 0
    this.oncekiDonemBakiye = 0
    this.oncekiDonemBorc = 0
    this.toplamAlacak = 0
    this.toplamBorc = 0
    this.donemAlacak = 0
    this.donemBorc = 0

    this.progress = true
    this.load1 = false



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var Evraklar1 = []
    if (this.secilenevraklar.length > 0) {
      Object.keys(this.secilenevraklar).forEach(key => {
        var evrak = {
          Evrakkod: this.secilenevraklar[key]
        }
        Evraklar1.push(evrak)
      });
    }

    this.KasaRapor.Evraklar = Evraklar1


    if (this.tumsirketler === true) {
      this.KasaRapor.SirketKodu = '0'
    } else {
      this.KasaRapor.SirketKodu = credentials.SirketKodu
    }
    this.KasaRapor.BaslangicTarih = this.date
    this.KasaRapor.BitisTarih = this.date2

    var params = this.KasaRapor


    this.$http
      .post(auth.API_URL + "api/Report/CaseReportHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "KasaRaporu.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        }
      })
  }

  function getListExcel() {
    this.devir = 0
    this.acilisDevir = 0
    this.kasaDevir = 0
    this.oncekiDonemAlacak = 0
    this.oncekiDonemBakiye = 0
    this.oncekiDonemBorc = 0
    this.toplamAlacak = 0
    this.toplamBorc = 0
    this.donemAlacak = 0
    this.donemBorc = 0

    this.progress = true
    this.load1 = false



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var Evraklar1 = []
    if (this.secilenevraklar.length > 0) {
      Object.keys(this.secilenevraklar).forEach(key => {
        var evrak = {
          Evrakkod: this.secilenevraklar[key]
        }
        Evraklar1.push(evrak)
      });
    }

    this.KasaRapor.Evraklar = Evraklar1


    if (this.tumsirketler === true) {
      this.KasaRapor.SirketKodu = '0'
    } else {
      this.KasaRapor.SirketKodu = credentials.SirketKodu
    }
    this.KasaRapor.BaslangicTarih = this.date
    this.KasaRapor.BitisTarih = this.date2

    var params = this.KasaRapor


    this.$http
      .post(auth.API_URL + "api/Report/CaseReportExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "KasaRaporu.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        }
      })
  }

  function beforeMount() {
    this.progress = true
    this.date = helpers.getDateNow()
    this.date2 =  helpers.getDateNow()
    this.load1 =false

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var Evrak1 = [{
      Evrakkod: null,
      BA: null,
      Aciklama: null,
      Cari: null,
    }]
    var Evraklar = []
    Evraklar.push(Evrak1)

    var params = {
      SirketKodu: credentials.SirketKodu,
      BaslangicTarih: this.date,
      BitisTarih: this.date2,
      Doviz: {
        DovizKod: null
      },
      Evraklar: Evraklar
    }
    this.$http.post(auth.API_URL + 'api/Report/CaseReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body.List
      this.devir = response.body.Devir.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.acilisDevir = response.body.AcilisDevir.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.kasaDevir = response.body.KasaDevir.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.oncekiDonemAlacak = response.body.OncekiDonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.oncekiDonemBakiye = response.body.OncekiDonemBakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.oncekiDonemBorc = response.body.OncekiDonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.toplamAlacak = response.body.ToplamAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.toplamBorc = response.body.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.donemAlacak = response.body.DonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.donemBorc = response.body.DonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

      this.progress = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      }
    })
  }

</script>


<style>
</style>